export const MBT_DATA_TYPE_MAGIC_NUMBER = 256;

export const hexToken = {
    F: {
        pattern: /[0-9a-fA-F]/,
        transform: v => v.toLocaleUpperCase()
    }
};